import { action } from 'easy-peasy';
import { IActionSetAllocationsFilter } from '../types';

const setAllocationsFilter: IActionSetAllocationsFilter = action((state, payload) => {
  state.allocationsFilter = payload;
});

export default setAllocationsFilter;
